import React, { useEffect, useState } from 'react';
import RouteConstants from '../../constants/routeConstants';
import { Box, CircularProgress, Paper } from '@mui/material';
 import Helper from '../../utility/helper';
import Title from '../../sharedcomponents/title/title';
import APIURLConstants from '../../config/config';
import ApiHelper from '../../utility/ApiHelper';
import { createTheme } from '@mui/system';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    root: {
        width: '100%',
        backgroundColor: "#DDE5F9 !important",
        height: 'calc(100vh - 70px)',
        maxHeight:'calc(100vh - 70px)'  
    },
})
const EndUserEventInstructionList = () => {
    const theme = createTheme();
    const classes = useStyles();
    const eventInfo = Helper.getStorage('eventInfo');
    const userInfo = Helper.getStorage('userInfo');
    const gAgentInfo = Helper.getSessionStorage('agentUser');
    const agentConnection = Helper.getSessionStorage('agentConnections');
    const [loading, setLoading] = useState(false);
    const [eventInstruction, setEventInstruction] = useState([]);

    useEffect(() => {
        setLoading(true)
        ApiHelper.get(
            APIURLConstants.GET_PARTICIPANT_INSTRUCTIONS_USER(eventInfo.eventID, agentConnection && gAgentInfo ? gAgentInfo.userID : userInfo.userID)
        )
            .then((res) => {
                // console.log("res", res);
                if (res.data.length > 0) {
                    setEventInstruction(res.data[0].instructionText)
                    setLoading(false)
                }
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
            });
    }, [])

    return (
        <Box
            className={classes.root}>
            <Box sx={{backgroundColor: "#DDE5F9 !important", pb: 2}}>
                <Title sx={{ margin:'15px 0px 0px 30px' }} title={'Event Allotment'} />
                {loading ? (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100%',
                            width: '100%',
                            marginTop: '15%',
                        }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <Box>
                        <Paper sx={{  boxShadow:'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
                    borderRadius: theme.spacing(3),
                    padding: theme.spacing(3),
                    maxHeight:'100%',
                    maxWidth:'100%',
                    display: 'flex',
                    margin:'10px 25px 25px 25px',
                    maxWidth:'100%',
                    boxSizing:'border-box',
                    overflow:'auto'}}> 
                                <div style={{ marginLeft: '1rem', fontFamily: 'Lato', marginTop: '10px' }}
                                    dangerouslySetInnerHTML={{
                                        __html: eventInstruction && eventInstruction,
                                    }} />
                        </Paper>
                    </Box>
                )} 
            </Box>

        </Box>
    );
}
export default {
    routeProps: {
        path: RouteConstants.END_USER_EVENT_INSTRUCTION,
        component: EndUserEventInstructionList,
    },
    name: 'Event Allotment',
};